module.exports = __webpack_public_path__ + "static/media/logo.df649f85.png";